//initial redux
import { put, call, takeEvery, fork, all, take, select } from "redux-saga/effects";
import * as router from "react-router-redux";
import { eventChannel, delay } from "redux-saga";
import pointsservice from "../../../services/points";
import moment from "moment-timezone";
import evidenceservice from "../../../services/evidence";
import {types as siteTypes} from "../../../ui/Home/redux";
import { array as arrayUtil } from "../../../utils";
import {types as sitetreetypes } from "../../../services/SiteTree/redux";
import {types as evidencetypes } from "../../../ui/Evidence/redux";
import {types as searchtypes } from "../../SearchBar/redux";
import {actions as evidenceactions} from "../../../ui/Evidence/redux";

//TODO: Copied from DailyFailureChart, needs to be modified/changed to work with the SEVEN things that need to display on the highchart.
// Top Chart
// 1 column - Verification Rule Failures
// 2 line - Ambient Temperature, Energy Costs/kWh
// 1 plotband - Per-Set Tests
// 3 Icon - Automated Actions, Diagnostic Rules, Implemented Changes

const initialState = {
	isBusy: false,
	isBusyAA: false,
	isBusyDR: false,
	isBusyIC: false,
	isBusyPST: false,
	isBusyVRF: false,
	isBusyCO: false,

	automatedActions: {
		isOpen: false,
		total: 0,
		years: [],
	},
	diagnosticRules: {
		isOpen: false,
		total: 0,
		years: [],
	},
	implementedChanges: {
		isOpen: false,
		values: [],
	},
	preSetTests: {
		isOpen: false,
		total: 0,
		years: [],
	},
	verificationRuleFailures: {
		isOpen: false,
		total: 0,
		years: [],
	},
	comments: {
		isOpen: false,
		total: 0,
		years: [],
	},
};

/////////
//types
export const types = {
	TOGGLE_AUTOMATED_ACTIONS: "Evidence/List/TOGGLE_AUTOMATED_ACTIONS",
	ON_TOGGLE_AUTOMATED_ACTIONS: "Evidence/List/ON_TOGGLE_AUTOMATED_ACTIONS",
	ON_TOGGLE_AUTOMATED_ACTIONS_FAILED: "Evidence/List/ON_TOGGLE_AUTOMATED_ACTIONS_FAILED",
	TOGGLE_AUTOMATED_ACTION_YEAR: "Evidence/List/TOGGLE_AUTOMATED_ACTION_YEAR",
	ON_TOGGLE_AUTOMATED_ACTION_YEAR: "Evidence/List/ON_TOGGLE_AUTOMATED_ACTION_YEAR",
	ON_TOGGLE_AUTOMATED_ACTION_YEAR_FAILED: "Evidence/List/ON_TOGGLE_AUTOMATED_ACTION_YEAR_FAILED",
	TOGGLE_AUTOMATED_ACTION_MONTH: "Evidence/List/TOGGLE_AUTOMATED_ACTION_MONTH",
	ON_TOGGLE_AUTOMATED_ACTION_MONTH: "Evidence/List/ON_TOGGLE_AUTOMATED_ACTION_MONTH",
	ON_TOGGLE_AUTOMATED_ACTION_MONTH_FAILED: "Evidence/List/ON_TOGGLE_AUTOMATED_ACTION_MONTH_FAILED",
	TOGGLE_AUTOMATED_ACTION_DAY: "Evidence/List/TOGGLE_AUTOMATED_ACTION_DAY",
	ON_TOGGLE_AUTOMATED_ACTION_DAY: "Evidence/List/ON_TOGGLE_AUTOMATED_ACTION_DAY",
	ON_TOGGLE_AUTOMATED_ACTION_DAY_FAILED: "Evidence/List/ON_TOGGLE_AUTOMATED_ACTION_DAY_FAILED",
	
	TOGGLE_DIAGNOSTIC_RULES: "Evidence/List/TOGGLE_DIAGNOSTIC_RULES",
	ON_TOGGLE_DIAGNOSTIC_RULES: "Evidence/List/ON_TOGGLE_DIAGNOSTIC_RULES",
	ON_TOGGLE_DIAGNOSTIC_RULES_FAILED: "Evidence/List/ON_TOGGLE_DIAGNOSTIC_RULES_FAILED",
	TOGGLE_DIAGNOSTIC_RULE_YEAR: "Evidence/List/TOGGLE_DIAGNOSTIC_RULE_YEAR",
	ON_TOGGLE_DIAGNOSTIC_RULE_YEAR: "Evidence/List/ON_TOGGLE_DIAGNOSTIC_RULE_YEAR",
	ON_TOGGLE_DIAGNOSTIC_RULE_YEAR_FAILED: "Evidence/List/ON_TOGGLE_DIAGNOSTIC_RULE_YEAR_FAILED",
	TOGGLE_DIAGNOSTIC_RULE_MONTH: "Evidence/List/TOGGLE_DIAGNOSTIC_RULE_MONTH",
	ON_TOGGLE_DIAGNOSTIC_RULE_MONTH: "Evidence/List/ON_TOGGLE_DIAGNOSTIC_RULE_MONTH",
	ON_TOGGLE_DIAGNOSTIC_RULE_MONTH_FAILED: "Evidence/List/ON_TOGGLE_DIAGNOSTIC_RULE_MONTH_FAILED",
	TOGGLE_DIAGNOSTIC_RULE_DAY: "Evidence/List/TOGGLE_DIAGNOSTIC_RULE_DAY",
	ON_TOGGLE_DIAGNOSTIC_RULE_DAY: "Evidence/List/ON_TOGGLE_DIAGNOSTIC_RULE_DAY",
	ON_TOGGLE_DIAGNOSTIC_RULE_DAY_FAILED: "Evidence/List/ON_TOGGLE_DIAGNOSTIC_RULE_DAY_FAILED",
	
	TOGGLE_IMPLEMENTED_CHANGES: "Evidence/List/TOGGLE_IMPLEMENTED_CHANGES",
	ON_TOGGLE_IMPLEMENTED_CHANGES: "Evidence/List/ON_TOGGLE_IMPLEMENTED_CHANGES",
	ON_TOGGLE_IMPLEMENTED_CHANGES_FAILED: "Evidence/List/ON_TOGGLE_IMPLEMENTED_CHANGES_FAILED",
	TOGGLE_IMPLEMENTED_CHANGE_YEAR: "Evidence/List/TOGGLE_IMPLEMENTED_CHANGE_YEAR",
	ON_TOGGLE_IMPLEMENTED_CHANGE_YEAR: "Evidence/List/ON_TOGGLE_IMPLEMENTED_CHANGE_YEAR",
	ON_TOGGLE_IMPLEMENTED_CHANGE_YEAR_FAILED: "Evidence/List/ON_TOGGLE_IMPLEMENTED_CHANGE_YEAR_FAILED",
	TOGGLE_IMPLEMENTED_CHANGE_MONTH: "Evidence/List/TOGGLE_IMPLEMENTED_CHANGE_MONTH",
	ON_TOGGLE_IMPLEMENTED_CHANGE_MONTH: "Evidence/List/ON_TOGGLE_IMPLEMENTED_CHANGE_MONTH",
	ON_TOGGLE_IMPLEMENTED_CHANGE_MONTH_FAILED: "Evidence/List/ON_TOGGLE_IMPLEMENTED_CHANGE_MONTH_FAILED",
	TOGGLE_IMPLEMENTED_CHANGE_DAY: "Evidence/List/TOGGLE_IMPLEMENTED_CHANGE_DAY",
	ON_TOGGLE_IMPLEMENTED_CHANGE_DAY: "Evidence/List/ON_TOGGLE_IMPLEMENTED_CHANGE_DAY",
	ON_TOGGLE_IMPLEMENTED_CHANGE_DAY_FAILED: "Evidence/List/ON_TOGGLE_IMPLEMENTED_CHANGE_DAY_FAILED",
	
	TOGGLE_PRE_SET_TESTS: "Evidence/List/TOGGLE_PRE_SET_TESTS",
	ON_TOGGLE_PRE_SET_TESTS: "Evidence/List/ON_TOGGLE_PRE_SET_TESTS",
	ON_TOGGLE_PRE_SET_TESTS_FAILED: "Evidence/List/ON_TOGGLE_PRE_SET_TESTS_FAILED",
	TOGGLE_PRE_SET_TEST_YEAR: "Evidence/List/TOGGLE_PRE_SET_TEST_YEAR",
	ON_TOGGLE_PRE_SET_TEST_YEAR: "Evidence/List/ON_TOGGLE_PRE_SET_TEST_YEAR",
	ON_TOGGLE_PRE_SET_TEST_YEAR_FAILED: "Evidence/List/ON_TOGGLE_PRE_SET_TEST_YEAR_FAILED",
	TOGGLE_PRE_SET_TEST_MONTH: "Evidence/List/TOGGLE_PRE_SET_TEST_MONTH",
	ON_TOGGLE_PRE_SET_TEST_MONTH: "Evidence/List/ON_TOGGLE_PRE_SET_TEST_MONTH",
	ON_TOGGLE_PRE_SET_TEST_MONTH_FAILED: "Evidence/List/ON_TOGGLE_PRE_SET_TEST_MONTH_FAILED",
	TOGGLE_PRE_SET_TEST_DAY: "Evidence/List/TOGGLE_PRE_SET_TEST_DAY",
	ON_TOGGLE_PRE_SET_TEST_DAY: "Evidence/List/ON_TOGGLE_PRE_SET_TEST_DAY",
	ON_TOGGLE_PRE_SET_TEST_DAY_FAILED: "Evidence/List/ON_TOGGLE_PRE_SET_TEST_DAY_FAILED",
	
	TOGGLE_VERIFICATION_RULE_FAILURES: "Evidence/List/TOGGLE_VERIFICATION_RULE_FAILURES",
	ON_TOGGLE_VERIFICATION_RULE_FAILURES: "Evidence/List/ON_TOGGLE_VERIFICATION_RULE_FAILURES",
	ON_TOGGLE_VERIFICATION_RULE_FAILURES_FAILED: "Evidence/List/ON_TOGGLE_VERIFICATION_RULE_FAILURES_FAILED",
	TOGGLE_VERIFICATION_RULE_FAILURE_YEAR: "Evidence/List/TOGGLE_VERIFICATION_RULE_FAILURE_YEAR",
	ON_TOGGLE_VERIFICATION_RULE_FAILURE_YEAR: "Evidence/List/ON_TOGGLE_VERIFICATION_RULE_FAILURE_YEAR",
	ON_TOGGLE_VERIFICATION_RULE_FAILURE_YEAR_FAILED: "Evidence/List/ON_TOGGLE_VERIFICATION_RULE_FAILURE_YEAR_FAILED",
	TOGGLE_VERIFICATION_RULE_FAILURE_MONTH: "Evidence/List/TOGGLE_VERIFICATION_RULE_FAILURE_MONTH",
	ON_TOGGLE_VERIFICATION_RULE_FAILURE_MONTH: "Evidence/List/ON_TOGGLE_VERIFICATION_RULE_FAILURE_MONTH",
	ON_TOGGLE_VERIFICATION_RULE_FAILURE_MONTH_FAILED: "Evidence/List/ON_TOGGLE_VERIFICATION_RULE_FAILURE_MONTH_FAILED",
	TOGGLE_VERIFICATION_RULE_FAILURE_DAY: "Evidence/List/TOGGLE_VERIFICATION_RULE_FAILURE_DAY",
	ON_TOGGLE_VERIFICATION_RULE_FAILURE_DAY: "Evidence/List/ON_TOGGLE_VERIFICATION_RULE_FAILURE_DAY",
	ON_TOGGLE_VERIFICATION_RULE_FAILURE_DAY_FAILED: "Evidence/List/ON_TOGGLE_VERIFICATION_RULE_FAILURE_DAY_FAILED",
	
	TOGGLE_COMMENTS: "Evidence/List/TOGGLE_COMMENTS",
	ON_TOGGLE_COMMENTS: "Evidence/List/ON_TOGGLE_COMMENTS",
	ON_TOGGLE_COMMENTS_FAILED: "Evidence/List/ON_TOGGLE_COMMENTS_FAILED",
	TOGGLE_COMMENT_YEAR: "Evidence/List/TOGGLE_COMMENT_YEAR",
	ON_TOGGLE_COMMENT_YEAR: "Evidence/List/ON_TOGGLE_COMMENT_YEAR",
	ON_TOGGLE_COMMENT_YEAR_FAILED: "Evidence/List/ON_TOGGLE_COMMENT_YEAR_FAILED",
	TOGGLE_COMMENT_MONTH: "Evidence/List/TOGGLE_COMMENT_MONTH",
	ON_TOGGLE_COMMENT_MONTH: "Evidence/List/ON_TOGGLE_COMMENT_MONTH",
	ON_TOGGLE_COMMENT_MONTH_FAILED: "Evidence/List/ON_TOGGLE_COMMENT_MONTH_FAILED",
	TOGGLE_COMMENT_DAY: "Evidence/List/TOGGLE_COMMENT_DAY",
	ON_TOGGLE_COMMENT_DAY: "Evidence/List/ON_TOGGLE_COMMENT_DAY",
	ON_TOGGLE_COMMENT_DAY_FAILED: "Evidence/List/ON_TOGGLE_COMMENT_DAY_FAILED",

	DELETE_IMPLEMENTED_CHANGE: "Evidence/List/DELETE_IMPLEMENTED_CHANGE",
	ON_DELETE_IMPLEMENTED_CHANGE: "Evidence/List/ON_DELETE_IMPLEMENTED_CHANGE",
	DELETE_PRE_SET_TEST: "Evidence/List/DELETE_PRE_SET_TEST",
	ON_DELETE_PRE_SET_TEST: "Evidence/List/ON_DELETE_PRE_SET_TEST",
	DELETE_COMMENT: "Evidence/List/DELETE_COMMENT",
	ON_DELETE_COMMENT: "Evidence/List/ON_DELETE_COMMENT",

	RESET_VALUES: "Evidence/List/RESET_VALUES",
};

///////////
//reducers
export const reducers = {
	reducer(state = initialState, action) {
		switch (action.type) {
			case types.ON_TOGGLE_AUTOMATED_ACTIONS:
			case types.ON_TOGGLE_AUTOMATED_ACTION_YEAR:
			case types.ON_TOGGLE_AUTOMATED_ACTION_MONTH:
			case types.ON_TOGGLE_AUTOMATED_ACTION_DAY:
				return { ...state, automatedActions: action.payload };
			case types.ON_TOGGLE_DIAGNOSTIC_RULES:
			case types.ON_TOGGLE_DIAGNOSTIC_RULE_YEAR:
			case types.ON_TOGGLE_DIAGNOSTIC_RULE_MONTH:
			case types.ON_TOGGLE_DIAGNOSTIC_RULE_DAY:
				return { ...state, diagnosticRules: action.payload };
			case types.ON_TOGGLE_IMPLEMENTED_CHANGES:
				return { ...state, implementedChanges: action.payload };
			case types.ON_TOGGLE_PRE_SET_TESTS:
			case types.ON_TOGGLE_PRE_SET_TEST_YEAR:
			case types.ON_TOGGLE_PRE_SET_TEST_MONTH:
			case types.ON_TOGGLE_PRE_SET_TEST_DAY:
				return { ...state, preSetTests: action.payload };
			case types.ON_TOGGLE_VERIFICATION_RULE_FAILURES:
			case types.ON_TOGGLE_VERIFICATION_RULE_FAILURE_YEAR:
			case types.ON_TOGGLE_VERIFICATION_RULE_FAILURE_MONTH:
			case types.ON_TOGGLE_VERIFICATION_RULE_FAILURE_DAY:
				return { ...state, verificationRuleFailures: action.payload };
			case types.ON_TOGGLE_COMMENTS:
			case types.ON_TOGGLE_COMMENT_YEAR:
			case types.ON_TOGGLE_COMMENT_MONTH:
			case types.ON_TOGGLE_COMMENT_DAY:
				return { ...state, comments: action.payload };
			case types.RESET_VALUES:
				return { ...state,
					automatedActions: {
						isOpen: false,
						total: 0,
						years: [],
					},
					diagnosticRules: {
						isOpen: false,
						total: 0,
						years: [],
					},
					implementedChanges: {
						isOpen: false,
						values: [],
					},
					preSetTests: {
						isOpen: false,
						total: 0,
						years: [],
					},
					verificationRuleFailures: {
						isOpen: false,
						total: 0,
						years: [],
					},
					comments: {
						isOpen: false,
						total: 0,
						years: [],
					}
				}
			case types.ON_DELETE_IMPLEMENTED_CHANGE:
				return { ...state, implementedChanges: action.payload }
			case types.ON_DELETE_PRE_SET_TEST:
				return { ...state, preSetTests: action.payload }
			case types.ON_DELETE_COMMENT:
				return { ...state, comments: action.payload }
			default:
				return state;
		}
	}
};

function sorter(a, b) {
	if(a.value > b.value) {
		return -1;
	}
	if(a.value < b.value) {
		return 1;
	}

	return 0;
}

function sortDayType(a, b, type) {
	switch(type) {
		case "AutomatedActions":
			if(a.siteLocalTime > b.siteLocalTime) { return -1;}
			if(a.siteLocalTime < b.siteLocalTime) { return 1;}
			return 0;
		case "PreSetTests":
			if(a.fromDate > b.fromDate) { return -1;}
			if(a.fromDate < b.fromDate) { return 1;}
			return 0;
		case "DiagnosticRules":
			if(a.dayStartSiteLocal > b.dayStartSiteLocal) { return -1;}
			if(a.dayStartSiteLocal < b.dayStartSiteLocal) { return 1;}
			return 0;
		case "VerificationRuleFailures":
			if(a.failCount > b.failCount) { return -1;}
			if(a.failCount < b.failCount) { return 1;}
			return 0;
		case "ImplementedChanges":
		case "Comments":
			if(a.implementedOn > b.implementedOn) { return -1;}
			if(a.implementedOn < b.implementedOn) { return 1;}
			return 0;
		default:
			return 0;
	}
}

function sortList(list, type) {
	list.years.sort(sorter);
	list.years.forEach(year => {
		if(year.months) {
			year.months.sort(sorter);
			year.months.forEach(month => {
				if(month.days) {
					month.days.sort(sorter);
					month.days.forEach(day => {
						if(day.values) {
							day.values.sort(function(a, b) {return sortDayType(a, b, type)});
						}
					});
				}
			});
		}
	});
}

function addItemToList (list, item, type) {
	let date = null;

	switch(type) {
		case "AutomatedActions":
			var utcOffset = moment(Date.now()).utcOffset();
			var m = moment(item.siteLocalTime).subtract(utcOffset, 'm');
			  date = m.toDate();
			break;
		case "PreSetTests":
			date = item.fromDate
			break;
		case "DiagnosticRules":
		case "VerificationRuleFailures":
			date = item.dayStartSiteLocal
			break;
		case "ImplementedChanges":
		case "Comments":
			date = item.implementedOn
			break;
		default:
			date = null;
	}

	if(date === null) {
		return;
	}

	const year = moment(date).year();
	const month = moment(date).month();
	const day = moment(date).date();
	
	let hasYear = false;
	let yearAt = -1;
	let hasMonth = false;
	let monthAt = -1;
	let hasDay = false;
	let dayAt = -1;

	if(year === 2019) {
		console.log('debug');
	}

	for(var ii = 0; ii < list.years.length; ii++) {
		if(list.years[ii].value === year) {
			hasYear = true;
			yearAt = ii;
			for(var jj = 0; jj < list.years[ii].months.length; jj++) {
				if(list.years[ii].months[jj].value === month) {
					hasMonth = true;
					monthAt = jj;
					for(var kk = 0; kk < list.years[ii].months[jj].days.length; kk++) {
						if(list.years[ii].months[jj].days[kk].value === day) {
							hasDay = true;
							dayAt = kk;
							break;
						}
					}

					if(hasDay === false) {
						list.years[ii].months[jj].days.push({
							isOpen: true,
							total: 0,
							value: day,
							values: [],
						});
						dayAt = list.years[ii].months[jj].days.length - 1;
					}

					break;
				}
			}

			if(hasMonth === false) {
				list.years[ii].months.push({
					isOpen: true,
					total: 0,
					value: month,
					days: [
						{
							isOpen: true,
							total: 0,
							value: day,
							values: [],
						}
					]
				});
				monthAt = list.years[ii].months.length - 1;
				dayAt = 0;
			}

			break;
		}
	}

	if(hasYear === false) {
		list.years.push({
			isOpen: true,
			total: 0,
			value: year,
			months: [
				{
					isOpen: true,
					total: 0,
					value: month,
					days: [
						{
							isOpen: true,
							total: 0,
							value: day,
							values: [],
						}
					]
				}
			]
		});

		yearAt = list.years.length - 1;
		monthAt = 0;
		dayAt = 0;
	}
	list.years[yearAt].months[monthAt].days[dayAt].values.push(item);
	list.years[yearAt].months[monthAt].days[dayAt].total++;
	list.years[yearAt].months[monthAt].total++;
	list.years[yearAt].total++;

	return list;
};

//////////
//sagas
export const sagas = {
	*rootSaga() {
		yield all([
			this.onSiteChange(),

			this.onToggleAutomatedActions(),
			this.onToggleAutomatedActionYear(),
			this.onToggleAutomatedActionMonth(),
			this.onToggleAutomatedActionDay(),

			this.onToggleDiagnosticRules(),
			this.onToggleDiagnosticRuleYear(),
			this.onToggleDiagnosticRuleMonth(),
			this.onToggleDiagnosticRuleDay(),

			this.onToggleImplementedChanges(),
			this.onToggleImplementedChangeYear(),
			this.onToggleImplementedChangeMonth(),
			this.onToggleImplementedChangeDay(),

			this.onTogglePreSetTests(),
			this.onTogglePreSetTestYear(),
			this.onTogglePreSetTestMonth(),
			this.onTogglePreSetTestDay(),

			this.onToggleVerificationRuleFailures(),
			this.onToggleVerificationRuleFailureYear(),
			this.onToggleVerificationRuleFailureMonth(),
			this.onToggleVerificationRuleFailureDay(),

			this.onToggleComments(),
			this.onToggleCommentYear(),
			this.onToggleCommentMonth(),
			this.onToggleCommentDay(),

			this.onDeleteImplementedChange(),
			this.onDeletePreSetTest(),
			this.onDeleteComment(),

			this.onSearch(),
			this.onClearSearch(),
		]);
	},

	*onClearSearch() {
		yield takeEvery(evidencetypes.CLEAR_SEARCH, function*({payload}) {
			yield put(actions.resetValues());
		});
	},

	*onDeleteImplementedChange() {
		yield takeEvery(types.DELETE_IMPLEMENTED_CHANGE, function*({payload}) {
			let { implementedChanges } = yield select(x => x.evidenceComponentList);

			var yearAt = -1;
			var monthAt = -1;
			var dayAt = -1;
			var valueAt = -1;
			if(implementedChanges && implementedChanges.years && implementedChanges.years.length > 0) {
				for(var ii = 0; ii < implementedChanges.years.length; ii++) {
					if(implementedChanges.years[ii] && implementedChanges.years[ii].months && implementedChanges.years[ii].months.length > 0) {
						for(var jj = 0; jj < implementedChanges.years[ii].months.length; jj++) {
							if(implementedChanges.years[ii].months[jj] && implementedChanges.years[ii].months[jj].days && implementedChanges.years[ii].months[jj].days.length > 0) {
								for(var kk = 0; kk < implementedChanges.years[ii].months[jj].days.length; kk++) {
									if(implementedChanges.years[ii].months[jj].days[kk] && implementedChanges.years[ii].months[jj].days[kk].values && implementedChanges.years[ii].months[jj].days[kk].values.length > 0) {
										for(var ll = 0; ll < implementedChanges.years[ii].months[jj].days[kk].values.length; ll++) {
											if(implementedChanges.years[ii].months[jj].days[kk].values[ll] && implementedChanges.years[ii].months[jj].days[kk].values[ll].implementedChangeId === payload) {
												yearAt = ii;
												monthAt = jj;
												dayAt = kk;
												valueAt = ll;
												break;
											}
										}
									}
								}
							}
						}
					}
				}
			}
			
			implementedChanges.years[yearAt].months[monthAt].days[dayAt].values.splice(valueAt, 1);
			implementedChanges.years[yearAt].months[monthAt].days[dayAt].total--;
			implementedChanges.years[yearAt].months[monthAt].total--;
			implementedChanges.years[yearAt].total--;

			yield put(actions.onDeleteImplementedChange(implementedChanges));
		});
	},

	*onDeletePreSetTest() {
		yield takeEvery(types.DELETE_PRE_SET_TEST, function*({payload}) {
			let { preSetTests } = yield select(x => x.evidenceComponentList);

			var yearAt = -1;
			var monthAt = -1;
			var dayAt = -1;
			var valueAt = -1;
			if(preSetTests && preSetTests.years && preSetTests.years.length > 0) {
				for(var ii = 0; ii < preSetTests.years.length; ii++) {
					if(preSetTests.years[ii] && preSetTests.years[ii].months && preSetTests.years[ii].months.length > 0) {
						for(var jj = 0; jj < preSetTests.years[ii].months.length; jj++) {
							if(preSetTests.years[ii].months[jj] && preSetTests.years[ii].months[jj].days && preSetTests.years[ii].months[jj].days.length > 0) {
								for(var kk = 0; kk < preSetTests.years[ii].months[jj].days.length; kk++) {
									if(preSetTests.years[ii].months[jj].days[kk] && preSetTests.years[ii].months[jj].days[kk].values && preSetTests.years[ii].months[jj].days[kk].values.length > 0) {
										for(var ll = 0; ll < preSetTests.years[ii].months[jj].days[kk].values.length; ll++) {
											if(preSetTests.years[ii].months[jj].days[kk].values[ll] && preSetTests.years[ii].months[jj].days[kk].values[ll].preSetTestId === payload) {
												yearAt = ii;
												monthAt = jj;
												dayAt = kk;
												valueAt = ll;
												break;
											}
										}
									}
								}
							}
						}
					}
				}
			}
			
			preSetTests.years[yearAt].months[monthAt].days[dayAt].values.splice(valueAt, 1);
			preSetTests.years[yearAt].months[monthAt].days[dayAt].total--;
			preSetTests.years[yearAt].months[monthAt].total--;
			preSetTests.years[yearAt].total--;

			yield put(actions.onDeletePreSetTest(preSetTests));
		});
	},

	*onDeleteComment() {
		yield takeEvery(types.DELETE_COMMENT, function*({payload}) {
			let { comments } = yield select(x => x.evidenceComponentList);

			var yearAt = -1;
			var monthAt = -1;
			var dayAt = -1;
			var valueAt = -1;
			if(comments && comments.years && comments.years.length > 0) {
				for(var ii = 0; ii < comments.years.length; ii++) {
					if(comments.years[ii] && comments.years[ii].months && comments.years[ii].months.length > 0) {
						for(var jj = 0; jj < comments.years[ii].months.length; jj++) {
							if(comments.years[ii].months[jj] && comments.years[ii].months[jj].days && comments.years[ii].months[jj].days.length > 0) {
								for(var kk = 0; kk < comments.years[ii].months[jj].days.length; kk++) {
									if(comments.years[ii].months[jj].days[kk] && comments.years[ii].months[jj].days[kk].values && comments.years[ii].months[jj].days[kk].values.length > 0) {
										for(var ll = 0; ll < comments.years[ii].months[jj].days[kk].values.length; ll++) {
											if(comments.years[ii].months[jj].days[kk].values[ll] && comments.years[ii].months[jj].days[kk].values[ll].commentId === payload) {
												yearAt = ii;
												monthAt = jj;
												dayAt = kk;
												valueAt = ll;
												break;
											}
										}
									}
								}
							}
						}
					}
				}
			}
			
			comments.years[yearAt].months[monthAt].days[dayAt].values.splice(valueAt, 1);
			comments.years[yearAt].months[monthAt].days[dayAt].total--;
			comments.years[yearAt].months[monthAt].total--;
			comments.years[yearAt].total--;

			yield put(actions.onDeletePreSetTest(comments));
		});
	},

	*onSearch() {
		yield takeEvery([evidencetypes.SEARCH, searchtypes.SEARCH_BAR_SUBMIT], function*({payload}) {
			if(payload && payload.searchBarId && payload.searchBarId !== "evidence/List") {
				return;
			}

			const isNullOrWhitespace = function( input ) {
				if (typeof input === 'undefined' || input == null) return true;
				return input.replace(/\s/g, '').length < 1;
			}
				
			let {searchText, searchValue} = yield select(x => x.evidenceChart);
			if (payload && payload.searchBarId && payload.searchBarId === "evidence/List") {
				searchText = payload.query;
			};

			const currentSite = yield select(x => x.sitetree.currentSite);
			yield put(evidenceactions.setSearchBusy());

			let siteTimezone = null;
			if(currentSite && currentSite.momentTimezone){
            siteTimezone = currentSite.momentTimezone;
        }

			if(isNullOrWhitespace(searchText)) {
				yield put(evidenceactions.clearSearch());
			} else {
				const results = yield call(evidenceservice.GetEvidenceListSearch, searchValue, currentSite.name, searchText);

				if(results instanceof Error) {
					yield put(evidencetypes.ON_SEARCH_FAILED, results);
				} else {
					let list = {
						isOpen: true,
						total: 0,
						years: [],
					}; 

					if(searchValue === "PreSetTests") {
						results.forEach((item) => {
							item.preSetTestItems.forEach((subitem) => {
								subitem.parent = item;
								list = addItemToList(list, subitem, searchValue);
							});
						});
					} else if(searchValue === "AutomatedActions") {
						results.forEach((item) => {
							item.siteTimezone = siteTimezone;
							list = addItemToList(list, item, searchValue);
						});
					} else {
						results.forEach((item) => {
							list = addItemToList(list, item, searchValue);
						});
					}

					sortList(list, searchValue);

					yield put(actions.resetValues());

					if(list.years.length > 0) {
						switch(searchValue) {
							case "AutomatedActions":
								yield put(actions.onToggleAutomatedActionDay(list));
								break;
							case "PreSetTests":
								yield put(actions.onTogglePreSetTestDay(list));
								break;
							case "DiagnosticRules":
								yield put(actions.onToggleDiagnosticRuleDay(list));
								break;
							case "VerificationRuleFailures":
								yield put(actions.onToggleVerificationRuleFailureDay(list));
								break;
							case "ImplementedChanges":
								yield put(actions.onToggleImplementedChangeDay(list));
								break;
							case "Comments":
								yield put(actions.onToggleCommentDay(list));
								break;
							default:
								break;
						}
					}

					yield put(evidenceactions.onSearch(results.length));
				}
			}
		});
	},

	*onSiteChange() {
		yield takeEvery([sitetreetypes.SET_CURRENT_SITE_BY_NAME, sitetreetypes.SET_CURRENT_SITE, sitetreetypes.ON_LOAD], function*({payload}) {
			yield put(actions.resetValues());
		});
	},

	*onToggleAutomatedActions() {
		yield takeEvery(types.TOGGLE_AUTOMATED_ACTIONS, function*({payload}) {
			const automatedActions = yield select(x => x.evidenceComponentList.automatedActions);
			const hasSearched = yield select(x => x.evidenceChart.hasSearched);
			
			let newAutomatedActions = {...automatedActions};

			let failed = false;
			if(!hasSearched) {
				if(payload.value) {
					const currentSite = yield select(x => x.sitetree.currentSite);
					const results = yield call(evidenceservice.GetEvidenceListYears, "AutomatedActions", currentSite.name);
					if(results instanceof Error) {
						yield actions.genericAction(types.ON_TOGGLE_AUTOMATED_ACTIONS_FAILED, results);
						failed = true;
					} else {
						newAutomatedActions.years = [];
						results.forEach(result => {
							newAutomatedActions.years.push({
								isOpen: false,
								value: result.value,
								total: result.total || 0
							})
						})
					}
				}
			}

			if(!failed) {
				newAutomatedActions.isOpen = payload.value;
				sortList(newAutomatedActions, "AutomatedActions");
				yield put(actions.onToggleAutomatedActions(newAutomatedActions));
			}
		});
	},
	*onToggleAutomatedActionYear() {
		yield takeEvery(types.TOGGLE_AUTOMATED_ACTION_YEAR, function*({payload}) {
			const automatedActions = yield select(x => x.evidenceComponentList.automatedActions);
			const hasSearched = yield select(x => x.evidenceChart.hasSearched);
			const { yearIndex } = payload;

			let newAutomatedActions = {...automatedActions};

			let failed = false;
			if(!hasSearched) {
				if(payload.value) {
					const currentSite = yield select(x => x.sitetree.currentSite);
					const results = yield call(evidenceservice.GetEvidenceListMonths, "AutomatedActions", currentSite.name, newAutomatedActions.years[yearIndex].value);
					if(results instanceof Error) {
						yield actions.genericAction(types.ON_TOGGLE_AUTOMATED_ACTION_YEAR_FAILED, results);
						failed = true;
					} else {
						newAutomatedActions.years[yearIndex].months = [];
						results.forEach(result => {
							newAutomatedActions.years[yearIndex].months.push({
								isOpen: false,
								value: result.value,
								total: result.total || 0
							})
						});
					}
				}
			}
			
			if(!failed) {
				newAutomatedActions.years[payload.yearIndex].isOpen = payload.value;
				sortList(newAutomatedActions, "AutomatedActions");
				yield put(actions.onToggleAutomatedActionYear(newAutomatedActions));
			}
		});
	},
	*onToggleAutomatedActionMonth() {
		yield takeEvery(types.TOGGLE_AUTOMATED_ACTION_MONTH, function*({payload}) {
			const automatedActions = yield select(x => x.evidenceComponentList.automatedActions);
			const hasSearched = yield select(x => x.evidenceChart.hasSearched);
			const { yearIndex, monthIndex } = payload;

			let newAutomatedActions = {...automatedActions};

			let failed = false;
			if(!hasSearched) {
				if(payload.value) {
					const currentSite = yield select(x => x.sitetree.currentSite);
					const results = yield call(evidenceservice.GetEvidenceListDays, "AutomatedActions", currentSite.name, newAutomatedActions.years[yearIndex].value, newAutomatedActions.years[yearIndex].months[monthIndex].value);
					if(results instanceof Error) {
						yield actions.genericAction(types.ON_TOGGLE_AUTOMATED_ACTION_MONTH_FAILED, results);
						failed = true;
					} else {
						newAutomatedActions.years[yearIndex].months[monthIndex].days = [];
						results.forEach(result => {
							newAutomatedActions.years[yearIndex].months[monthIndex].days.push({
								isOpen: false,
								value: result.value,
								total: result.total || 0
							})
						});
					}
				}
			}

			if(!failed) {
				newAutomatedActions.years[yearIndex].months[monthIndex].isOpen = payload.value;
				sortList(newAutomatedActions, "AutomatedActions");
				yield put(actions.onToggleAutomatedActionMonth(newAutomatedActions));
			}
		});
	},
	*onToggleAutomatedActionDay() {
		yield takeEvery(types.TOGGLE_AUTOMATED_ACTION_DAY, function*({payload}) {
			const automatedActions = yield select(x => x.evidenceComponentList.automatedActions);
			const hasSearched = yield select(x => x.evidenceChart.hasSearched);
			const { yearIndex, monthIndex, dayIndex } = payload;

			let newAutomatedActions = {...automatedActions};

			let failed = false;
			if(!hasSearched) {
				if(payload.value) {
					const currentSite = yield select(x => x.sitetree.currentSite);
					const results = yield call(evidenceservice.GetEvidenceListIndividuals, "AutomatedActions", currentSite.name, newAutomatedActions.years[yearIndex].value, newAutomatedActions.years[yearIndex].months[monthIndex].value, newAutomatedActions.years[yearIndex].months[monthIndex].days[dayIndex].value);
					if(results instanceof Error) {
						yield actions.genericAction(types.ON_TOGGLE_AUTOMATED_ACTION_DAY_FAILED, results);
						failed = true;
					} else {
						newAutomatedActions.years[yearIndex].months[monthIndex].days[dayIndex].values = [];
						results.forEach(result => {
							newAutomatedActions.years[yearIndex].months[monthIndex].days[dayIndex].values.push(result);
						});
					}
				}
			}

			if(!failed) {
				newAutomatedActions.years[yearIndex].months[monthIndex].days[dayIndex].isOpen = payload.value;
				sortList(newAutomatedActions, "AutomatedActions");
				yield put(actions.onToggleAutomatedActionDay(newAutomatedActions));
			}
		});
	},

	*onToggleDiagnosticRules() {
		yield takeEvery(types.TOGGLE_DIAGNOSTIC_RULES, function*({payload}) {
			const diagnosticRules = yield select(x => x.evidenceComponentList.diagnosticRules);
			const hasSearched = yield select(x => x.evidenceChart.hasSearched);
			
			let newDiagnosticRules = {...diagnosticRules};

			let failed = false;
			if(!hasSearched) {
				if(payload.value) {
					const currentSite = yield select(x => x.sitetree.currentSite);
					const results = yield call(evidenceservice.GetEvidenceListYears, "DiagnosticRules", currentSite.name);
					if(results instanceof Error) {
						yield actions.genericAction(types.ON_TOGGLE_DIAGNOSTIC_RULES_FAILED, results);
						failed = true;
					} else {
						newDiagnosticRules.years = [];
						results.forEach(result => {
							newDiagnosticRules.years.push({
								isOpen: false,
								value: result.value,
								total: result.total || 0
							})
						})
					}
				}
			}

			if(!failed) {
				newDiagnosticRules.isOpen = payload.value;
				sortList(newDiagnosticRules, "DiagnosticRules");
				yield put(actions.onToggleDiagnosticRules(newDiagnosticRules));
			}
		});
	},
	*onToggleDiagnosticRuleYear() {
		yield takeEvery(types.TOGGLE_DIAGNOSTIC_RULE_YEAR, function*({payload}) {
			const diagnosticRules = yield select(x => x.evidenceComponentList.diagnosticRules);
			const hasSearched = yield select(x => x.evidenceChart.hasSearched);
			const { yearIndex } = payload;

			let newDiagnosticRules = {...diagnosticRules};

			let failed = false;
			if(!hasSearched) {
				if(payload.value) {
					const currentSite = yield select(x => x.sitetree.currentSite);
					const results = yield call(evidenceservice.GetEvidenceListMonths, "DiagnosticRules", currentSite.name, newDiagnosticRules.years[yearIndex].value);
					if(results instanceof Error) {
						yield actions.genericAction(types.ON_TOGGLE_DIAGNOSTIC_RULE_YEAR_FAILED, results);
						failed = true;
					} else {
						newDiagnosticRules.years[yearIndex].months = [];
						results.forEach(result => {
							newDiagnosticRules.years[yearIndex].months.push({
								isOpen: false,
								value: result.value,
								total: result.total || 0
							})
						});
					}
				}
			}
			
			if(!failed) {
				newDiagnosticRules.years[payload.yearIndex].isOpen = payload.value;
				sortList(newDiagnosticRules, "DiagnosticRules");
				yield put(actions.onToggleDiagnosticRuleYear(newDiagnosticRules));
			}
		});
	},
	*onToggleDiagnosticRuleMonth() {
		yield takeEvery(types.TOGGLE_DIAGNOSTIC_RULE_MONTH, function*({payload}) {
			const diagnosticRules = yield select(x => x.evidenceComponentList.diagnosticRules);
			const hasSearched = yield select(x => x.evidenceChart.hasSearched);
			const { yearIndex, monthIndex } = payload;

			let newDiagnosticRules = {...diagnosticRules};

			let failed = false;
			if(!hasSearched) {
				if(payload.value) {
					const currentSite = yield select(x => x.sitetree.currentSite);
					const results = yield call(evidenceservice.GetEvidenceListDays, "DiagnosticRules", currentSite.name, newDiagnosticRules.years[yearIndex].value, newDiagnosticRules.years[yearIndex].months[monthIndex].value);
					if(results instanceof Error) {
						yield actions.genericAction(types.ON_TOGGLE_DIAGNOSTIC_RULE_MONTH_FAILED, results);
						failed = true;
					} else {
						newDiagnosticRules.years[yearIndex].months[monthIndex].days = [];
						results.forEach(result => {
							newDiagnosticRules.years[yearIndex].months[monthIndex].days.push({
								isOpen: false,
								value: result.value,
								total: result.total || 0
							})
						});
					}
				}
			}

			if(!failed) {
				newDiagnosticRules.years[yearIndex].months[monthIndex].isOpen = payload.value;
				sortList(newDiagnosticRules, "DiagnosticRules");
				yield put(actions.onToggleDiagnosticRuleMonth(newDiagnosticRules));
			}
		});
	},
	*onToggleDiagnosticRuleDay() {
		yield takeEvery(types.TOGGLE_DIAGNOSTIC_RULE_DAY, function*({payload}) {
			const diagnosticRules = yield select(x => x.evidenceComponentList.diagnosticRules);
			const hasSearched = yield select(x => x.evidenceChart.hasSearched);
			const { yearIndex, monthIndex, dayIndex } = payload;

			let newDiagnosticRules = {...diagnosticRules};

			let failed = false;
			if(!hasSearched) {
				if(payload.value) {
					const currentSite = yield select(x => x.sitetree.currentSite);
					const results = yield call(evidenceservice.GetEvidenceListIndividuals, "DiagnosticRules", currentSite.name, newDiagnosticRules.years[yearIndex].value, newDiagnosticRules.years[yearIndex].months[monthIndex].value, newDiagnosticRules.years[yearIndex].months[monthIndex].days[dayIndex].value);
					if(results instanceof Error) {
						yield actions.genericAction(types.ON_TOGGLE_DIAGNOSTIC_RULE_DAY_FAILED, results);
						failed = true;
					} else {
						newDiagnosticRules.years[yearIndex].months[monthIndex].days[dayIndex].values = [];
						results.forEach(result => {
							newDiagnosticRules.years[yearIndex].months[monthIndex].days[dayIndex].values.push(result);
						});
					}
				}
			}

			if(!failed) {
				newDiagnosticRules.years[yearIndex].months[monthIndex].days[dayIndex].isOpen = payload.value;
				sortList(newDiagnosticRules, "DiagnosticRules");
				yield put(actions.onToggleDiagnosticRuleDay(newDiagnosticRules));
			}
		});
	},

	*onToggleImplementedChanges() {
		yield takeEvery(types.TOGGLE_IMPLEMENTED_CHANGES, function*({payload}) {
			const implementedChanges = yield select(x => x.evidenceComponentList.implementedChanges);
			const hasSearched = yield select(x => x.evidenceChart.hasSearched);
			
			let newImplementedChanges = {...implementedChanges};

			let failed = false;
			if(!hasSearched) {
				if(payload.value) {
					const currentSite = yield select(x => x.sitetree.currentSite);
					const results = yield call(evidenceservice.GetEvidenceListFlat, "ImplementedChanges", currentSite.name);
					
					//const results = yield call(evidenceservice.GetEvidenceListYears, "ImplementedChanges", currentSite.name);
					if(results instanceof Error) {
						yield actions.genericAction(types.ON_TOGGLE_IMPLEMENTED_CHANGES_FAILED, results);
						failed = true;
					} else {
						newImplementedChanges.values = [];
						results.forEach(result => {
							newImplementedChanges.values.push(result);
						});
					}
				}
			}

			if(!failed) {
				newImplementedChanges.isOpen = payload.value;
				yield put(actions.onToggleImplementedChanges(newImplementedChanges));
			}
		});
	},
	*onToggleImplementedChangeYear() {
		yield takeEvery(types.TOGGLE_IMPLEMENTED_CHANGE_YEAR, function*({payload}) {
			const implementedChanges = yield select(x => x.evidenceComponentList.implementedChanges);
			const hasSearched = yield select(x => x.evidenceChart.hasSearched);
			const { yearIndex } = payload;

			let newImplementedChanges = {...implementedChanges};

			let failed = false;
			if(!hasSearched) {
				if(payload.value) {
					const currentSite = yield select(x => x.sitetree.currentSite);
					const results = yield call(evidenceservice.GetEvidenceListMonths, "ImplementedChanges", currentSite.name, newImplementedChanges.years[yearIndex].value);
					if(results instanceof Error) {
						yield actions.genericAction(types.ON_TOGGLE_IMPLEMENTED_CHANGE_YEAR_FAILED, results);
						failed = true;
					} else {
						newImplementedChanges.years[yearIndex].months = [];
						results.forEach(result => {
							newImplementedChanges.years[yearIndex].months.push({
								isOpen: false,
								value: result.value,
								total: result.total || 0
							})
						});
					}
				}
			}
			
			if(!failed) {
				newImplementedChanges.years[payload.yearIndex].isOpen = payload.value;
				sortList(newImplementedChanges, "ImplementedChanges");
				yield put(actions.onToggleImplementedChangeYear(newImplementedChanges));
			}
		});
	},
	*onToggleImplementedChangeMonth() {
		yield takeEvery(types.TOGGLE_IMPLEMENTED_CHANGE_MONTH, function*({payload}) {
			const implementedChanges = yield select(x => x.evidenceComponentList.implementedChanges);
			const hasSearched = yield select(x => x.evidenceChart.hasSearched);
			const { yearIndex, monthIndex } = payload;

			let newImplementedChanges = {...implementedChanges};

			let failed = false;
			if(!hasSearched) {
				if(payload.value) {
					const currentSite = yield select(x => x.sitetree.currentSite);
					const results = yield call(evidenceservice.GetEvidenceListDays, "ImplementedChanges", currentSite.name, newImplementedChanges.years[yearIndex].value, newImplementedChanges.years[yearIndex].months[monthIndex].value);
					if(results instanceof Error) {
						yield actions.genericAction(types.ON_TOGGLE_IMPLEMENTED_CHANGE_MONTH_FAILED, results);
						failed = true;
					} else {
						newImplementedChanges.years[yearIndex].months[monthIndex].days = [];
						results.forEach(result => {
							newImplementedChanges.years[yearIndex].months[monthIndex].days.push({
								isOpen: false,
								value: result.value,
								total: result.total || 0
							})
						});
					}
				}
			}

			if(!failed) {
				newImplementedChanges.years[yearIndex].months[monthIndex].isOpen = payload.value;
				sortList(newImplementedChanges, "ImplementedChanges");
				yield put(actions.onToggleImplementedChangeMonth(newImplementedChanges));
			}
		});
	},
	*onToggleImplementedChangeDay() {
		yield takeEvery(types.TOGGLE_IMPLEMENTED_CHANGE_DAY, function*({payload}) {
			const implementedChanges = yield select(x => x.evidenceComponentList.implementedChanges);
			const hasSearched = yield select(x => x.evidenceChart.hasSearched);
			const { yearIndex, monthIndex, dayIndex } = payload;

			let newImplementedChanges = {...implementedChanges};

			let failed = false;
			if(!hasSearched) {
				if(payload.value) {
					const currentSite = yield select(x => x.sitetree.currentSite);
					const results = yield call(evidenceservice.GetEvidenceListIndividuals, "ImplementedChanges", currentSite.name, newImplementedChanges.years[yearIndex].value, newImplementedChanges.years[yearIndex].months[monthIndex].value, newImplementedChanges.years[yearIndex].months[monthIndex].days[dayIndex].value);
					if(results instanceof Error) {
						yield actions.genericAction(types.ON_TOGGLE_IMPLEMENTED_CHANGE_DAY_FAILED, results);
						failed = true;
					} else {
						newImplementedChanges.years[yearIndex].months[monthIndex].days[dayIndex].values = [];
						results.forEach(result => {
							newImplementedChanges.years[yearIndex].months[monthIndex].days[dayIndex].values.push(result);
						});
					}
				}
			}

			if(!failed) {
				newImplementedChanges.years[yearIndex].months[monthIndex].days[dayIndex].isOpen = payload.value;
				sortList(newImplementedChanges, "ImplementedChanges");
				yield put(actions.onToggleImplementedChangeDay(newImplementedChanges));
			}
		});
	},

	*onTogglePreSetTests() {
		yield takeEvery(types.TOGGLE_PRE_SET_TESTS, function*({payload}) {
			const preSetTests = yield select(x => x.evidenceComponentList.preSetTests);
			const hasSearched = yield select(x => x.evidenceChart.hasSearched);
			
			let newPreSetTests = {...preSetTests};

			let failed = false;
			if(!hasSearched) {
				if(payload.value) {
					const currentSite = yield select(x => x.sitetree.currentSite);
					const results = yield call(evidenceservice.GetEvidenceListYears, "PreSetTests", currentSite.name);
					if(results instanceof Error) {
						yield actions.genericAction(types.ON_TOGGLE_PRE_SET_TESTS_FAILED, results);
						failed = true;
					} else {
						newPreSetTests.years = [];
						results.forEach(result => {
							newPreSetTests.years.push({
								isOpen: false,
								value: result.value,
								total: result.total || 0
							})
						})
					}
				}
			}

			if(!failed) {
				newPreSetTests.isOpen = payload.value;
				sortList(newPreSetTests, "PreSetTests");
				yield put(actions.onTogglePreSetTests(newPreSetTests));
			}
		});
	},
	*onTogglePreSetTestYear() {
		yield takeEvery(types.TOGGLE_PRE_SET_TEST_YEAR, function*({payload}) {
			const preSetTests = yield select(x => x.evidenceComponentList.preSetTests);
			const hasSearched = yield select(x => x.evidenceChart.hasSearched);
			const { yearIndex } = payload;

			let newPreSetTests = {...preSetTests};

			let failed = false;
			if(!hasSearched) {
				if(payload.value) {
					const currentSite = yield select(x => x.sitetree.currentSite);
					const results = yield call(evidenceservice.GetEvidenceListMonths, "PreSetTests", currentSite.name, newPreSetTests.years[yearIndex].value);
					if(results instanceof Error) {
						yield actions.genericAction(types.ON_TOGGLE_PRE_SET_TEST_YEAR_FAILED, results);
						failed = true;
					} else {
						newPreSetTests.years[yearIndex].months = [];
						results.forEach(result => {
							newPreSetTests.years[yearIndex].months.push({
								isOpen: false,
								value: result.value,
								total: result.total || 0
							})
						});
					}
				}
			}
			
			if(!failed) {
				newPreSetTests.years[payload.yearIndex].isOpen = payload.value;
				sortList(newPreSetTests, "PreSetTests");
				yield put(actions.onTogglePreSetTestYear(newPreSetTests));
			}
		});
	},
	*onTogglePreSetTestMonth() {
		yield takeEvery(types.TOGGLE_PRE_SET_TEST_MONTH, function*({payload}) {
			const preSetTests = yield select(x => x.evidenceComponentList.preSetTests);
			const hasSearched = yield select(x => x.evidenceChart.hasSearched);
			const { yearIndex, monthIndex } = payload;

			let newPreSetTests = {...preSetTests};

			let failed = false;
			if(!hasSearched) {
				if(payload.value) {
					const currentSite = yield select(x => x.sitetree.currentSite);
					const results = yield call(evidenceservice.GetEvidenceListDays, "PreSetTests", currentSite.name, newPreSetTests.years[yearIndex].value, newPreSetTests.years[yearIndex].months[monthIndex].value);
					if(results instanceof Error) {
						yield actions.genericAction(types.ON_TOGGLE_PRE_SET_TEST_MONTH_FAILED, results);
						failed = true;
					} else {
						newPreSetTests.years[yearIndex].months[monthIndex].days = [];
						results.forEach(result => {
							newPreSetTests.years[yearIndex].months[monthIndex].days.push({
								isOpen: false,
								value: result.value,
								total: result.total || 0
							})
						});
					}
				}
			}

			if(!failed) {
				newPreSetTests.years[yearIndex].months[monthIndex].isOpen = payload.value;
				sortList(newPreSetTests, "PreSetTests");
				yield put(actions.onTogglePreSetTestMonth(newPreSetTests));
			}
		});
	},
	*onTogglePreSetTestDay() {
		yield takeEvery(types.TOGGLE_PRE_SET_TEST_DAY, function*({payload}) {
			const preSetTests = yield select(x => x.evidenceComponentList.preSetTests);
			const hasSearched = yield select(x => x.evidenceChart.hasSearched);
			const { yearIndex, monthIndex, dayIndex } = payload;

			let newPreSetTests = {...preSetTests};

			let failed = false;
			if(!hasSearched) {
				if(payload.value) {
					const currentSite = yield select(x => x.sitetree.currentSite);
					const results = yield call(evidenceservice.GetEvidenceListIndividuals, "PreSetTests", currentSite.name, newPreSetTests.years[yearIndex].value, newPreSetTests.years[yearIndex].months[monthIndex].value, newPreSetTests.years[yearIndex].months[monthIndex].days[dayIndex].value);
					if(results instanceof Error) {
						yield actions.genericAction(types.ON_TOGGLE_PRE_SET_TEST_DAY_FAILED, results);
						failed = true;
					} else {
						newPreSetTests.years[yearIndex].months[monthIndex].days[dayIndex].values = [];
						results.forEach(result => {
							newPreSetTests.years[yearIndex].months[monthIndex].days[dayIndex].values.push(result);
						});
					}
				}
			}

			if(!failed) {
				newPreSetTests.years[yearIndex].months[monthIndex].days[dayIndex].isOpen = payload.value;
				sortList(newPreSetTests, "PreSetTests");
				yield put(actions.onTogglePreSetTestDay(newPreSetTests));
			}
		});
	},

	*onToggleVerificationRuleFailures() {
		yield takeEvery(types.TOGGLE_VERIFICATION_RULE_FAILURES, function*({payload}) {
			const verificationRuleFailures = yield select(x => x.evidenceComponentList.verificationRuleFailures);
			const hasSearched = yield select(x => x.evidenceChart.hasSearched);
			
			let newVerificationRuleFailures = {...verificationRuleFailures};

			let failed = false;
			if(!hasSearched) {
				if(payload.value) {
					const currentSite = yield select(x => x.sitetree.currentSite);
					const results = yield call(evidenceservice.GetEvidenceListYears, "VerificationRuleFailures", currentSite.name);
					if(results instanceof Error) {
						yield actions.genericAction(types.ON_TOGGLE_VERIFICATION_RULE_FAILURES_FAILED, results);
						failed = true;
					} else {
						newVerificationRuleFailures.years = [];
						results.forEach(result => {
							newVerificationRuleFailures.years.push({
								isOpen: false,
								value: result.value,
								total: result.total || 0
							})
						})
					}
				}
			}

			if(!failed) {
				newVerificationRuleFailures.isOpen = payload.value;
				sortList(newVerificationRuleFailures, "VerificationRuleFailures");
				yield put(actions.onToggleVerificationRuleFailures(newVerificationRuleFailures));
			}
		});
	},
	*onToggleVerificationRuleFailureYear() {
		yield takeEvery(types.TOGGLE_VERIFICATION_RULE_FAILURE_YEAR, function*({payload}) {
			const verificationRuleFailures = yield select(x => x.evidenceComponentList.verificationRuleFailures);
			const hasSearched = yield select(x => x.evidenceChart.hasSearched);
			const { yearIndex } = payload;

			let newVerificationRuleFailures = {...verificationRuleFailures};

			let failed = false;
			if(!hasSearched) {
				if(payload.value) {
					const currentSite = yield select(x => x.sitetree.currentSite);
					const results = yield call(evidenceservice.GetEvidenceListMonths, "VerificationRuleFailures", currentSite.name, newVerificationRuleFailures.years[yearIndex].value);
					if(results instanceof Error) {
						yield actions.genericAction(types.ON_TOGGLE_VERIFICATION_RULE_FAILURE_YEAR_FAILED, results);
						failed = true;
					} else {
						newVerificationRuleFailures.years[yearIndex].months = [];
						results.forEach(result => {
							newVerificationRuleFailures.years[yearIndex].months.push({
								isOpen: false,
								value: result.value,
								total: result.total || 0
							})
						});
					}
				}
			}
			
			if(!failed) {
				newVerificationRuleFailures.years[payload.yearIndex].isOpen = payload.value;
				sortList(newVerificationRuleFailures, "VerificationRuleFailures");
				yield put(actions.onToggleVerificationRuleFailureYear(newVerificationRuleFailures));
			}
		});
	},
	*onToggleVerificationRuleFailureMonth() {
		yield takeEvery(types.TOGGLE_VERIFICATION_RULE_FAILURE_MONTH, function*({payload}) {
			const verificationRuleFailures = yield select(x => x.evidenceComponentList.verificationRuleFailures);
			const hasSearched = yield select(x => x.evidenceChart.hasSearched);
			const { yearIndex, monthIndex } = payload;

			let newVerificationRuleFailures = {...verificationRuleFailures};

			let failed = false;
			if(!hasSearched) {
				if(payload.value) {
					const currentSite = yield select(x => x.sitetree.currentSite);
					const results = yield call(evidenceservice.GetEvidenceListDays, "VerificationRuleFailures", currentSite.name, newVerificationRuleFailures.years[yearIndex].value, newVerificationRuleFailures.years[yearIndex].months[monthIndex].value);
					if(results instanceof Error) {
						yield actions.genericAction(types.ON_TOGGLE_VERIFICATION_RULE_FAILURE_MONTH_FAILED, results);
						failed = true;
					} else {
						newVerificationRuleFailures.years[yearIndex].months[monthIndex].days = [];
						results.forEach(result => {
							newVerificationRuleFailures.years[yearIndex].months[monthIndex].days.push({
								isOpen: false,
								value: result.value,
								total: result.total || 0
							})
						});
					}
				}
			}

			if(!failed) {
				newVerificationRuleFailures.years[yearIndex].months[monthIndex].isOpen = payload.value;
				sortList(newVerificationRuleFailures, "VerificationRuleFailures");
				yield put(actions.onToggleVerificationRuleFailureMonth(newVerificationRuleFailures));
			}
		});
	},
	*onToggleVerificationRuleFailureDay() {
		yield takeEvery(types.TOGGLE_VERIFICATION_RULE_FAILURE_DAY, function*({payload}) {
			const verificationRuleFailures = yield select(x => x.evidenceComponentList.verificationRuleFailures);
			const hasSearched = yield select(x => x.evidenceChart.hasSearched);
			const { yearIndex, monthIndex, dayIndex } = payload;

			let newVerificationRuleFailures = {...verificationRuleFailures};

			let failed = false;
			if(!hasSearched) {
				if(payload.value) {
					const currentSite = yield select(x => x.sitetree.currentSite);
					const results = yield call(evidenceservice.GetEvidenceListIndividuals, "VerificationRuleFailures", currentSite.name, newVerificationRuleFailures.years[yearIndex].value, newVerificationRuleFailures.years[yearIndex].months[monthIndex].value, newVerificationRuleFailures.years[yearIndex].months[monthIndex].days[dayIndex].value);
					if(results instanceof Error) {
						yield actions.genericAction(types.ON_TOGGLE_VERIFICATION_RULE_FAILURE_DAY_FAILED, results);
						failed = true;
					} else {
						newVerificationRuleFailures.years[yearIndex].months[monthIndex].days[dayIndex].values = [];
						results.forEach(result => {
							newVerificationRuleFailures.years[yearIndex].months[monthIndex].days[dayIndex].values.push(result);
						});
					}
				}
			}

			if(!failed) {
				newVerificationRuleFailures.years[yearIndex].months[monthIndex].days[dayIndex].isOpen = payload.value;
				sortList(newVerificationRuleFailures, "VerificationRuleFailures");
				yield put(actions.onToggleVerificationRuleFailureDay(newVerificationRuleFailures));
			}
		});
	},

	*onToggleComments() {
		yield takeEvery(types.TOGGLE_COMMENTS, function*({payload}) {
			const comments = yield select(x => x.evidenceComponentList.comments);
			const hasSearched = yield select(x => x.evidenceChart.hasSearched);
			
			let newComments = {...comments};

			let failed = false;
			if(!hasSearched) {
				if(payload.value) {
					const currentSite = yield select(x => x.sitetree.currentSite);
					const results = yield call(evidenceservice.GetEvidenceListYears, "Comments", currentSite.name);
					if(results instanceof Error) {
						yield actions.genericAction(types.ON_TOGGLE_COMMENTS_FAILED, results);
						failed = true;
					} else {
						newComments.years = [];
						results.forEach(result => {
							newComments.years.push({
								isOpen: false,
								value: result.value,
								total: result.total || 0
							})
						})
					}
				}
			}

			if(!failed) {
				newComments.isOpen = payload.value;
				sortList(newComments, "Comments");
				yield put(actions.onToggleComments(newComments));
			}
		});
	},
	*onToggleCommentYear() {
		yield takeEvery(types.TOGGLE_COMMENT_YEAR, function*({payload}) {
			const comments = yield select(x => x.evidenceComponentList.comments);
			const hasSearched = yield select(x => x.evidenceChart.hasSearched);
			const { yearIndex } = payload;

			let newComments = {...comments};

			let failed = false;
			if(!hasSearched) {
				if(payload.value) {
					const currentSite = yield select(x => x.sitetree.currentSite);
					const results = yield call(evidenceservice.GetEvidenceListMonths, "Comments", currentSite.name, newComments.years[yearIndex].value);
					if(results instanceof Error) {
						yield actions.genericAction(types.ON_TOGGLE_COMMENT_YEAR_FAILED, results);
						failed = true;
					} else {
						newComments.years[yearIndex].months = [];
						results.forEach(result => {
							newComments.years[yearIndex].months.push({
								isOpen: false,
								value: result.value,
								total: result.total || 0
							})
						});
					}
				}
			}
			
			if(!failed) {
				newComments.years[payload.yearIndex].isOpen = payload.value;
				sortList(newComments, "Comments");
				yield put(actions.onToggleCommentYear(newComments));
			}
		});
	},
	*onToggleCommentMonth() {
		yield takeEvery(types.TOGGLE_COMMENT_MONTH, function*({payload}) {
			const comments = yield select(x => x.evidenceComponentList.comments);
			const hasSearched = yield select(x => x.evidenceChart.hasSearched);
			const { yearIndex, monthIndex } = payload;

			let newComments = {...comments};

			let failed = false;
			if(!hasSearched) {
				if(payload.value) {
					const currentSite = yield select(x => x.sitetree.currentSite);
					const results = yield call(evidenceservice.GetEvidenceListDays, "Comments", currentSite.name, newComments.years[yearIndex].value, newComments.years[yearIndex].months[monthIndex].value);
					if(results instanceof Error) {
						yield actions.genericAction(types.ON_TOGGLE_COMMENT_MONTH_FAILED, results);
						failed = true;
					} else {
						newComments.years[yearIndex].months[monthIndex].days = [];
						results.forEach(result => {
							newComments.years[yearIndex].months[monthIndex].days.push({
								isOpen: false,
								value: result.value,
								total: result.total || 0
							})
						});
					}
				}
			}

			if(!failed) {
				newComments.years[yearIndex].months[monthIndex].isOpen = payload.value;
				sortList(newComments, "Comments");
				yield put(actions.onToggleCommentMonth(newComments));
			}
		});
	},
	*onToggleCommentDay() {
		yield takeEvery(types.TOGGLE_COMMENT_DAY, function*({payload}) {
			const comments = yield select(x => x.evidenceComponentList.comments);
			const hasSearched = yield select(x => x.evidenceChart.hasSearched);
			const { yearIndex, monthIndex, dayIndex } = payload;

			let newComments = {...comments};

			let failed = false;
			if(!hasSearched) {
				if(payload.value) {
					const currentSite = yield select(x => x.sitetree.currentSite);
					const results = yield call(evidenceservice.GetEvidenceListIndividuals, "Comments", currentSite.name, newComments.years[yearIndex].value, newComments.years[yearIndex].months[monthIndex].value, newComments.years[yearIndex].months[monthIndex].days[dayIndex].value);
					if(results instanceof Error) {
						yield actions.genericAction(types.ON_TOGGLE_COMMENT_DAY_FAILED, results);
						failed = true;
					} else {
						newComments.years[yearIndex].months[monthIndex].days[dayIndex].values = [];
						results.forEach(result => {
							newComments.years[yearIndex].months[monthIndex].days[dayIndex].values.push(result);
						});
					}
				}
			}

			if(!failed) {
				newComments.years[yearIndex].months[monthIndex].days[dayIndex].isOpen = payload.value;
				sortList(newComments, "Comments");
				yield put(actions.onToggleCommentDay(newComments));
			}
		});
	},
	
};

////////
//actions
export const actions = {
	resetValues() {
		return {
			type: types.RESET_VALUES,
		}
	},
	toggleAutomatedActions(value) {
		return {
			type: types.TOGGLE_AUTOMATED_ACTIONS,
			payload: {value}
		}
	},
	toggleAutomatedActionYear(yearIndex, value) {
		return {
			type: types.TOGGLE_AUTOMATED_ACTION_YEAR,
			payload: {yearIndex, value}
		}
	},
	toggleAutomatedActionMonth(yearIndex, monthIndex, value) {
		return {
			type: types.TOGGLE_AUTOMATED_ACTION_MONTH,
			payload: {yearIndex, monthIndex, value}
		}
	},
	toggleAutomatedActionDay(yearIndex, monthIndex, dayIndex, value) {
		return {
			type: types.TOGGLE_AUTOMATED_ACTION_DAY,
			payload: {yearIndex, monthIndex, dayIndex, value}
		}
	},
	onToggleAutomatedActions(payload) {
		return {
			type: types.ON_TOGGLE_AUTOMATED_ACTIONS,
			payload
		}
	},
	onToggleAutomatedActionYear(payload) {
		return {
			type: types.ON_TOGGLE_AUTOMATED_ACTION_YEAR,
			payload
		}
	},
	onToggleAutomatedActionMonth(payload) {
		return {
			type: types.ON_TOGGLE_AUTOMATED_ACTION_MONTH,
			payload
		}
	},
	onToggleAutomatedActionDay(payload) {
		return {
			type: types.ON_TOGGLE_AUTOMATED_ACTION_DAY,
			payload
		}
	},


	
	toggleDiagnosticRules(value) {
		return {
			type: types.TOGGLE_DIAGNOSTIC_RULES,
			payload: {value}
		}
	},
	toggleDiagnosticRuleYear(yearIndex, value) {
		return {
			type: types.TOGGLE_DIAGNOSTIC_RULE_YEAR,
			payload: {yearIndex, value}
		}
	},
	toggleDiagnosticRuleMonth(yearIndex, monthIndex, value) {
		return {
			type: types.TOGGLE_DIAGNOSTIC_RULE_MONTH,
			payload: {yearIndex, monthIndex, value}
		}
	},
	toggleDiagnosticRuleDay(yearIndex, monthIndex, dayIndex, value) {
		return {
			type: types.TOGGLE_DIAGNOSTIC_RULE_DAY,
			payload: {yearIndex, monthIndex, dayIndex, value}
		}
	},
	onToggleDiagnosticRules(payload) {
		return {
			type: types.ON_TOGGLE_DIAGNOSTIC_RULES,
			payload
		}
	},
	onToggleDiagnosticRuleYear(payload) {
		return {
			type: types.ON_TOGGLE_DIAGNOSTIC_RULE_YEAR,
			payload
		}
	},
	onToggleDiagnosticRuleMonth(payload) {
		return {
			type: types.ON_TOGGLE_DIAGNOSTIC_RULE_MONTH,
			payload
		}
	},
	onToggleDiagnosticRuleDay(payload) {
		return {
			type: types.ON_TOGGLE_DIAGNOSTIC_RULE_DAY,
			payload
		}
	},
	
	toggleImplementedChanges(value) {
		return {
			type: types.TOGGLE_IMPLEMENTED_CHANGES,
			payload: {value}
		}
	},
	toggleImplementedChangeYear(yearIndex, value) {
		return {
			type: types.TOGGLE_IMPLEMENTED_CHANGE_YEAR,
			payload: {yearIndex, value}
		}
	},
	toggleImplementedChangeMonth(yearIndex, monthIndex, value) {
		return {
			type: types.TOGGLE_IMPLEMENTED_CHANGE_MONTH,
			payload: {yearIndex, monthIndex, value}
		}
	},
	toggleImplementedChangeDay(yearIndex, monthIndex, dayIndex, value) {
		return {
			type: types.TOGGLE_IMPLEMENTED_CHANGE_DAY,
			payload: {yearIndex, monthIndex, dayIndex, value}
		}
	},
	onToggleImplementedChanges(payload) {
		return {
			type: types.ON_TOGGLE_IMPLEMENTED_CHANGES,
			payload
		}
	},
	onToggleImplementedChangeYear(payload) {
		return {
			type: types.ON_TOGGLE_IMPLEMENTED_CHANGE_YEAR,
			payload
		}
	},
	onToggleImplementedChangeMonth(payload) {
		return {
			type: types.ON_TOGGLE_IMPLEMENTED_CHANGE_MONTH,
			payload
		}
	},
	onToggleImplementedChangeDay(payload) {
		return {
			type: types.ON_TOGGLE_IMPLEMENTED_CHANGE_DAY,
			payload
		}
	},
	
	togglePreSetTests(value) {
		return {
			type: types.TOGGLE_PRE_SET_TESTS,
			payload: {value}
		}
	},
	togglePreSetTestYear(yearIndex, value) {
		return {
			type: types.TOGGLE_PRE_SET_TEST_YEAR,
			payload: {yearIndex, value}
		}
	},
	togglePreSetTestMonth(yearIndex, monthIndex, value) {
		return {
			type: types.TOGGLE_PRE_SET_TEST_MONTH,
			payload: {yearIndex, monthIndex, value}
		}
	},
	togglePreSetTestDay(yearIndex, monthIndex, dayIndex, value) {
		return {
			type: types.TOGGLE_PRE_SET_TEST_DAY,
			payload: {yearIndex, monthIndex, dayIndex, value}
		}
	},
	onTogglePreSetTests(payload) {
		return {
			type: types.ON_TOGGLE_PRE_SET_TESTS,
			payload
		}
	},
	onTogglePreSetTestYear(payload) {
		return {
			type: types.ON_TOGGLE_PRE_SET_TEST_YEAR,
			payload
		}
	},
	onTogglePreSetTestMonth(payload) {
		return {
			type: types.ON_TOGGLE_PRE_SET_TEST_MONTH,
			payload
		}
	},
	onTogglePreSetTestDay(payload) {
		return {
			type: types.ON_TOGGLE_PRE_SET_TEST_DAY,
			payload
		}
	},
	
	toggleVerificationRuleFailures(value) {
		return {
			type: types.TOGGLE_VERIFICATION_RULE_FAILURES,
			payload: {value}
		}
	},
	toggleVerificationRuleFailureYear(yearIndex, value) {
		return {
			type: types.TOGGLE_VERIFICATION_RULE_FAILURE_YEAR,
			payload: {yearIndex, value}
		}
	},
	toggleVerificationRuleFailureMonth(yearIndex, monthIndex, value) {
		return {
			type: types.TOGGLE_VERIFICATION_RULE_FAILURE_MONTH,
			payload: {yearIndex, monthIndex, value}
		}
	},
	toggleVerificationRuleFailureDay(yearIndex, monthIndex, dayIndex, value) {
		return {
			type: types.TOGGLE_VERIFICATION_RULE_FAILURE_DAY,
			payload: {yearIndex, monthIndex, dayIndex, value}
		}
	},
	onToggleVerificationRuleFailures(payload) {
		return {
			type: types.ON_TOGGLE_VERIFICATION_RULE_FAILURES,
			payload
		}
	},
	onToggleVerificationRuleFailureYear(payload) {
		return {
			type: types.ON_TOGGLE_VERIFICATION_RULE_FAILURE_YEAR,
			payload
		}
	},
	onToggleVerificationRuleFailureMonth(payload) {
		return {
			type: types.ON_TOGGLE_VERIFICATION_RULE_FAILURE_MONTH,
			payload
		}
	},
	onToggleVerificationRuleFailureDay(payload) {
		return {
			type: types.ON_TOGGLE_VERIFICATION_RULE_FAILURE_DAY,
			payload
		}
	},
	
	toggleComments(value) {
		return {
			type: types.TOGGLE_COMMENTS,
			payload: {value}
		}
	},
	toggleCommentYear(yearIndex, value) {
		return {
			type: types.TOGGLE_COMMENT_YEAR,
			payload: {yearIndex, value}
		}
	},
	toggleCommentMonth(yearIndex, monthIndex, value) {
		return {
			type: types.TOGGLE_COMMENT_MONTH,
			payload: {yearIndex, monthIndex, value}
		}
	},
	toggleCommentDay(yearIndex, monthIndex, dayIndex, value) {
		return {
			type: types.TOGGLE_COMMENT_DAY,
			payload: {yearIndex, monthIndex, dayIndex, value}
		}
	},
	onToggleComments(payload) {
		return {
			type: types.ON_TOGGLE_COMMENTS,
			payload
		}
	},
	onToggleCommentYear(payload) {
		return {
			type: types.ON_TOGGLE_COMMENT_YEAR,
			payload
		}
	},
	onToggleCommentMonth(payload) {
		return {
			type: types.ON_TOGGLE_COMMENT_MONTH,
			payload
		}
	},
	onToggleCommentDay(payload) {
		return {
			type: types.ON_TOGGLE_COMMENT_DAY,
			payload
		}
	},
	deleteImplementedChange(payload) {
		return {
			type: types.DELETE_IMPLEMENTED_CHANGE,
			payload
		}
	},
	onDeleteImplementedChange(payload) {
		return {
			type: types.ON_DELETE_IMPLEMENTED_CHANGE,
			payload
		}
	},
	deletePreSetTest(payload) {
		return {
			type: types.DELETE_PRE_SET_TEST,
			payload
		}
	},
	onDeletePreSetTest(payload) {
		return {
			type: types.ON_DELETE_PRE_SET_TEST,
			payload
		}
	},
	deleteComment(payload) {
		return {
			type: types.DELETE_COMMENT,
			payload
		}
	},
	onDeleteComment(payload) {
		return {
			type: types.ON_DELETE_COMMENT,
			payload
		}
	},
	resetCurrentLoaded() {
		return {
			type: types.RESET_VALUES,
		}
	},

	genericAction(type, data) {
		return {
			type,
			payload: data
		};
	}
};



// WEBPACK FOOTER //
// ./src/components/EvidenceComponents/List/redux.js